import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferReturnPayload } from 'api/actions/price-offer-return/price-offer-return-payload';
import { PriceOfferReturnPathParameters } from 'api/actions/price-offer-return/price-offer-return-path-parameters';
import { PriceOfferReturnResponse } from 'api/actions/price-offer-return/price-offer-return-response';

type PriceOfferReturnQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferReturn action.
 */
export const priceOfferReturnActionPath = new SweetPath<keyof PriceOfferReturnPathParameters>(
  '/api/price-offer/return/{priceOfferId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferReturn actions.
 */
export default function createPriceOfferReturnAction(axios: AxiosInstance) {
  return function priceOfferReturnAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PriceOfferReturnPathParameters;
    query?: PriceOfferReturnQueryParameters;
    payload: PriceOfferReturnPayload;
  }) {
    const path = priceOfferReturnActionPath.insert(parameters);

    return axios.request<PriceOfferReturnResponse, PriceOfferReturnResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
